import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchFacetRefinementCheckboxes } from '@uncinc/react-searchkit';

import { FACET_LIMIT } from '../../../config/constants';
import SearchFacets from '../../Search/Facets';

import './style.scss';

const SearchAllContentFacets: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Facets');

  return (
    <SearchFacets className={classNames}>
      <SearchFacetRefinementCheckboxes
        attribute="targetAudience"
        title={t('components.search.facets.target_audience.label')}
        sortBy={['count:desc']}
        showMore
        showMoreText={t('components.search.facets.show_more.label')}
        limit={FACET_LIMIT}
      />

      <SearchFacetRefinementCheckboxes
        attribute="theme"
        title={t('components.search.facets.theme.label')}
        sortBy={['count:desc']}
        showMore
        showMoreText={t('components.search.facets.show_more.label')}
        limit={FACET_LIMIT}
      />
    </SearchFacets>
  );
};

export default SearchAllContentFacets;
